import { OutputElement, PassageText } from "./outputElement";
import { SlideOptionsData } from "../components/SlideOptions";
import { CustomText } from "./inputRow";

export interface PreformattedText {
  reference: string;
  slideTexts: string[][]; // The lines for each slide
}

export const formatForClipboard = (e: PreformattedText[], referenceAbove: boolean) => {
  let r = "";
  for (const pt of e) {
    const refLine = (referenceAbove ? pt.reference : "").trim();
    for (const st of pt.slideTexts) {
      r += refLine + (refLine !== "" ? "\n" : "");
      const textLine = st.join("").trim();
      r += textLine + (textLine !== "" ? "\n\n" : "\n");
    }
  }
  return r.trim();
};

const containsCharOf = (t: string, s: string[]) => {
  for (const c of s) {
    if (t.includes(c)) {
      return true;
    }
  }
  return false;
};

export const preformatCustomText = (e: CustomText, o: SlideOptionsData): PreformattedText => {
  return preformatText(e, e.reference, o);
};

export const preformatPassageText = (e: PassageText, o: SlideOptionsData): PreformattedText => {
  const p = `${e.passage.book} ${e.passage.chapter}${e.passage.chapter !== "" ? "," : ""}${e.passage.verses} (${e.passage.translation.split("(")[1].replace(")", "")})`;
  return preformatText(e, p, o);
};

const cleanText = (e: string): string => {
  // Remove bracketed content like [abc 123]
  const text = e
    .replace(/\[[a-zäöüA-ZÄÖÜ0-9 ]+\]/g, "")

    // Normalize all whitespace to a single space
    .replace(/\s+/g, " ")
    .replace(/\u00A0/g, " ") // non-breaking space
    .replace(/\u2000/g, " ") // en quad
    .replace(/\u2001/g, " ") // em quad
    .replace(/\u2002/g, " ") // en space
    .replace(/\u2003/g, " ") // em space
    .replace(/\u2004/g, " ") // three-per-em space
    .replace(/\u2005/g, " ") // four-per-em space
    .replace(/\u2006/g, " ") // six-per-em space
    .replace(/\u2007/g, " ") // figure space
    .replace(/\u2008/g, " ") // punctuation space
    .replace(/\u2009/g, " ") // thin space
    .replace(/\u200A/g, " ") // hair space
    .replace(/\u202F/g, " ") // narrow no-break space
    .replace(/\u205F/g, " ") // medium mathematical space
    .replace(/\u3000/g, " ") // ideographic space

    // Remove left/right angled brackets
    .replaceAll("⟨", "")
    .replaceAll("⟩", "")

    // Remove asterisks
    .replaceAll("*", "")

    // Replace m-dash and n-dash with regular dash
    .replaceAll("—", "-")
    .replaceAll("–", "-")

    // Remove typographic quotation marks
    .replaceAll("›", "")
    .replaceAll("‹", "")
    .replaceAll("»", "")
    .replaceAll("«", "")
    .replaceAll("“", "")
    .replaceAll("”", "")
    .replaceAll("„", "")
    .replaceAll("‟", "")
    .replaceAll("´", "")
    .replaceAll("`", "")
    .replaceAll("‘", "")

    // Remove right single quote only if it is NOT inside a word
    .replace(/(^|[^a-zA-Z0-9])’([^a-zA-Z0-9]|$)/g, "$1$2")

    // Remove spaces before common punctuation
    .replace(/ ([.,;:!?]) /g, "$1 ")

    // Normalize any multiple spaces again just in case
    .replace(/\s+/g, " ")

    // Trim leading/trailing whitespace
    .trim();

  return text;
};

export const preformatText = (e: OutputElement, p: string, o: SlideOptionsData): PreformattedText => {
  p = o.upperCase ? p.toUpperCase() : p;
  let t = cleanText(e.text);
  t = o.upperCase ? t.toUpperCase() : t;
  const splt = t.split(" ");
  let charCount = 0;
  let lineCount = 0;
  let r: string[][] = [];
  let s: string[] = [];
  let l = "";
  for (const i in splt) {
    const e = splt[i];
    charCount += e.length + 1;
    l += e.trim() + " ";
    if (lineCount > o.linesPerSlide - 2) {
      if (containsCharOf(e, o.newSlideAfter) || charCount > o.charactersPerLine) {
        charCount = 0;
        lineCount = 0;
        s.push(l);
        l = "";
        r.push(s);
        s = [];
      }
    } else {
      if (charCount > o.charactersPerLine) {
        charCount = 0;
        lineCount++;
        if (Number(i) !== splt.length - 1) {
          s.push(l);
          l = "";
        }
      }
    }
  }
  if (l.length > 0) {
    s.push(l);
  }
  if (s.length > 0) {
    r.push(s);
  }
  return {
    reference: p,
    slideTexts: r,
  };
};
